import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { legalDocuments } from "@/content/legalDocuments";

export default function OrderingPolicy() {
  return <LegalDocumentPage document={legalDocuments.ordering} />;
}